module.exports = __webpack_public_path__ + "img/1x.8d91783.jpg";